// extracted by mini-css-extract-plugin
export default {"time_widget":"TimeWidget_time_widget__k67se","player":"TimeWidget_player__sN-aM"};